export const SET_CURRENT_BREADCRUMB = "@@@common.act.SET_CURRENT_BREADCRUMB";

export const SET_BREADCRUMB = "@@@common.act.SET_BREADCRUMB";
